import { Users } from 'lucide-react'

export default function AdminUsersPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Zarządzanie użytkownikami</h1>
        <p className="text-gray-500">Dodawaj i zarządzaj użytkownikami organizacji</p>
      </div>

      <div className="card p-8 text-center">
        <Users className="w-12 h-12 mx-auto text-gray-300 mb-4" />
        <p className="text-gray-500">Panel użytkowników zostanie wkrótce dodany</p>
      </div>
    </div>
  )
}
